import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { getItemValuesForCondition } from './getItemValuesForCondition';
import { toConditionDisplayName } from './toConditionDisplayName';
import { getItemDisplayValuesForActions } from './getItemDisplayValuesForActions';
import { TruncateString } from '../../../../lib/helpers/StringHelper';

export function generateRuleDescription(item: SmartSendItemApiModel, actions: string[], selectedConditions: string[]) {
  return `Applies '${getItemDisplayValuesForActions(item, actions)}' based on ${TruncateString(
    selectedConditions.map((c) => `${toConditionDisplayName(c)} (${getItemValuesForCondition(item, c)})`).join(' or '),
    250
  )}.`;
}
